import React, { useEffect, useRef, useState } from "react";
import DoctorAddBasicInfo from "./Large-forms/DoctorAddBasicInfo";
import { handleNext, handleBack } from "./Helper-Functions/DoctorStepperNav";
import { useFormik } from "formik";
import DoctorProfessionalInfo from "./Large-forms/DoctorProfessionalInfo";
import DoctorClinicDetails from "./Large-forms/DoctorClinicDetails";
import DoctorAddEduInfo from "./Large-forms/DoctorAddEduInfo";
import { generateValidationSchema } from "./Validations";

import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUserDoctor } from "react-icons/fa6";
import { GoArrowLeft } from "react-icons/go";
import { Link} from "react-router-dom";
import { useAddDoctorMutation, useGetDoctorQuery } from "../State/Api/AdddocApiSlice";

function DoctorsStepper() {
  const [currentStep, setCurrentStep] = useState(1);
  const [doctorData, setDoctorData] = useState({});

  const apiToCall = useRef("createDoctor");

  const navigate = useNavigate();
  const location = useLocation();
  const { id: doctorIdFromParams } = useParams(); 
  
     const query = new URLSearchParams(location.search);
  const from = query.get("from"); 

    const handleMoveBack = () => {
    if (from) {
      navigate(from);
    } else {
   
      navigate(-1);
    }
  };

  const doctorIdFromState = doctorIdFromParams;

  const isEditMode = Boolean(doctorIdFromState);
  const skipQuery = !doctorIdFromState;


  const [addDoctor, { isLoading, isError, error }] = useAddDoctorMutation();

  const {
    data: doctorapiData,
    refetch,
    isLoading: doctorapiLoading,
    isFetching,
    isSuccess,
  } = useGetDoctorQuery(doctorIdFromState, { skip: skipQuery });

useEffect(() => {
  if (doctorIdFromState) {
    refetch(); 
  } else {
 
    apiToCall.current = "createDoctor";
    setDoctorData({});
  }
}, [doctorIdFromState]);


  useEffect(() => {
    if (doctorapiData) {
      apiToCall.current = "updateDoctor";
      setDoctorData(doctorapiData);
    }
  }, [doctorapiData]);



  const clinicUserId = localStorage.getItem("userClinicID");

  const useruniqueid = localStorage.getItem("userUniqueID");

  const formFields = [
    "email",
    "fullname",
    "gender",
    "dateofbirth",
    "phonenumber",
    "address",
    "specialization",
    "yearsofexperience",
    "medicallicensenumber",
    "professionalaffiliations",
    "languagesknown",
    "Eductioncertificates",
    // "refferedby",
  ];

  const handleNext = async (currentStep, steps, setCurrentStep, formik) => {
    try {
      const errors = await formik.validateForm();

      const step1Fields = [
        "fullname",
        "gender",
        "dateofbirth",
        "phonenumber",
        "email",
        "ProfilePicture",
        "languagesknown",
        // "refferedby",
        "address",
        "specialization",
        "yearsofexperience",
        "medicallicensenumber",
        "professionalaffiliations",
      ];

      const firstErrorField = step1Fields.find((field) => !!errors[field]);

      if (!firstErrorField) {
        setCurrentStep(currentStep + 1);
      } else {
        formik.setTouched(
          step1Fields.reduce((acc, field) => {
            acc[field] = true;
            return acc;
          }, {}),
          true
        );

        toast.error(`${errors[firstErrorField]}`);
      }
    } catch (err) {
      console.error("Validation error:", err);
      toast.error("Validation failed.");
    }
  };

  const validationSchema = generateValidationSchema(formFields);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userclinicid: localStorage.getItem("userClinicID") ?? "",
      useruniqueid:
        doctorData?.basicinfo?.useruniqueid &&
        doctorData.basicinfo.useruniqueid !== "undefined"
          ? doctorData.basicinfo.useruniqueid
          : localStorage.getItem("userUniqueID") ?? "",
      DoctorId: doctorData?.basicinfo?.doctorId ?? 0,
      fullname: doctorData?.basicinfo?.fullname ?? "",
      dateofbirth: doctorData?.basicinfo?.dateofbirth
        ? dayjs(doctorData.basicinfo.dateofbirth).format("YYYY-MM-DD")
        : "",
      gender: doctorData?.basicinfo?.gender ?? "",
      phonenumber: (doctorData?.basicinfo?.phonenumber ?? ""),
      email: doctorData?.basicinfo?.emailaddress ?? "",
      address: doctorData?.basicinfo?.office_clinicaddress ?? "",
      languagesknown:
        doctorData?.basicinfo?.languages_Known
          ?.split(",")
          .map((lang) => lang.trim()) ?? [],

      refferedby: doctorData?.basicinfo?.reffered_By ?? "",
      ProfilePicture: doctorData?.basicinfo?.imageURL ?? null, // Leave null for new upload

      specialization:
        doctorData?.professionalinfo?.specialization
          ?.split(",")
          .map((s) => s.trim()) ?? [],
      yearsofexperience: doctorData?.professionalinfo?.experience ?? "",
      medicallicensenumber:
        doctorData?.professionalinfo?.medicallicensenumber ?? "",
      professionalaffiliations:
        doctorData?.professionalinfo?.professionalaffiliations ?? "",
      professionaldoctorId: doctorData?.professionalinfo?.doctorid ?? 0,

      Eductioncertificates:
        doctorData?.eductioncertificates?.length > 0
          ? doctorData.eductioncertificates.map((item) => ({
              educationcertificationid: item.educationcertificationid ?? 0,
              doctorid: item.doctorid ?? "",
              useruniqueid: item.useruniqueid ?? "",
              userclinicid: item.userclinicid ?? "",

              highestQualification: item.qualification ?? "",
              university: item.university ?? "",
              fieldofstudy: item.fieldofStudy ?? "",
              certifications: item.certifications ?? "",
              percentage: item.percentages ?? "",
              startDate: item.startdate
                ? dayjs(item.startdate).format("YYYY-MM-DD")
                : "",
              endDate: item.lastdate
                ? dayjs(item.lastdate).format("YYYY-MM-DD")
                : "",
            }))
          : [],
    },

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const formData = new FormData();

        const safeAppend = (key, value) => {
          if (value !== undefined && value !== null && value !== "undefined") {
            formData.append(key, value);
          }
        };

        // Basic Info
        safeAppend("basicinfo.userclinicid", values.userclinicid);
        safeAppend("basicinfo.useruniqueid", values.useruniqueid);
        safeAppend("basicinfo.DoctorId", values.DoctorId);
        safeAppend("basicinfo.fullname", values.fullname);
        safeAppend("basicinfo.gender", values.gender);
        safeAppend("basicinfo.phonenumber", values.phonenumber);
        safeAppend("basicinfo.emailaddress", values.email);
        safeAppend("basicinfo.office_clinicaddress", values.address);
        safeAppend(
          "basicinfo.dateofbirth",
          dayjs(values.dateofbirth).format("YYYY-MM-DD")
        );
        safeAppend(
          "basicinfo.languages_Known",
          values.languagesknown?.join(", ")
        );
        safeAppend("basicinfo.reffered_By", values.refferedby);
        safeAppend("basicinfo.isactive", "true");
        if (values.ProfilePicture)
          safeAppend("basicinfo.ImageURL", values.ProfilePicture);

        // Professional Info

        safeAppend("professionalinfo.userclinicid", values.userclinicid);
        safeAppend("professionalinfo.useruniqueid", values.useruniqueid);
        safeAppend("professionalinfo.doctorid", values.professionaldoctorId);
        safeAppend(
          "professionalinfo.specialization",
          values.specialization?.join(", ")
        );
        safeAppend("professionalinfo.experience", values.yearsofexperience);
        safeAppend(
          "professionalinfo.medicallicensenumber",
          values.medicallicensenumber
        );
        safeAppend(
          "professionalinfo.professionalaffiliations",
          values.professionalaffiliations
        );
        safeAppend("professionalinfo.isactive", "true");

        // Education Certificates
        if (values.Eductioncertificates?.length > 0) {
          const educationPayload = values.Eductioncertificates.map((edu) => ({
            doctorid: edu.doctorid,
            useruniqueid: values.useruniqueid,
            userclinicid: values.userclinicid,
            university: edu.university,
            qualification: edu.highestQualification,
            fieldofStudy: edu.fieldofstudy,
            startdate: dayjs(edu.startDate).format("YYYY-MM-DD") === "Invalid Date" ? "" : dayjs(edu.startDate).format("YYYY-MM-DD"),
            lastdate: dayjs(edu.endDate).format("YYYY-MM-DD") === "Invalid Date" ? "" : dayjs(edu.endDate).format("YYYY-MM-DD"),
            percentages: edu.percentage,
            certifications: edu.certifications,
            isactive: 1,
            
          }));

          safeAppend("Eductioncertificates", JSON.stringify(educationPayload));
        }

        // Submit
        const response = await addDoctor(formData).unwrap();

        if (response.result_Code === 100 || response.result_Code === 200) {
          toast.success("Submitted Successfully", { autoClose: 3000 });
        } else {
          console.error("API Error:", response.message);
        }
      } catch (err) {
        console.error("Submission Error:", err);
      }
    },
  });

  const customSubmit = (e) => {
    e.preventDefault();
  };

  const [draftEducation, setDraftEducation] = useState({
    doctorid: doctorData?.doctorid ?? 0,
    highestQualification: "",
    university: "",
    fieldofstudy: "",
    certifications: "",
    percentage: "",
    startDate: "",
    endDate: "",
  });

  const [editEducationIndex, setEditEducationIndex] = useState(null);

  function handleRemoval(type, index) {
    if (type === "education") {
      const mutatededucation = formik.values.Eductioncertificates.filter(
        (experience, index) => index !== editEducationIndex
      );
      formik.setFieldValue("Eductioncertificates", mutatededucation);
      setEditEducationIndex(mutatededucation?.length - 1);
    }
  }

  const steps = [
    {
      content: (
        <>
          <DoctorAddBasicInfo formik={formik} isEditMode={isEditMode} />

          <DoctorProfessionalInfo formik={formik} isEditMode={isEditMode}/>
        </>
      ),
    },

    {
      content: (
        <>
          {/* <DoctorClinicDetails formik={formik} /> */}

          <DoctorAddEduInfo
            eduVars={{
              draftEducation,
              setDraftEducation,
              editEducationIndex,
              setEditEducationIndex,
              formik,
              doctorData,
              handleRemoval,
            }}
          />
        </>
      ),
    },
  ];

  const progressWidth = (currentStep / steps.length) * 100;

  let content = null;


    const Antdstyles = `
  .ant-upload-wrapper .ant-upload-select {
    width: 100% !important;
  }

  .ant-steps.ant-steps-vertical > .ant-steps-item .ant-steps-item-title {
    line-height: 14px !important;
  }



  .ant-steps-item-tail {
      padding: 42px 0 6px  !important;
  }

  :where(.css-dev-only-do-not-override-apn68).ant-steps.ant-steps-vertical >.ant-steps-item>.ant-steps-item-container>.ant-steps-item-tail::after {
      width: 4px;
  height: 47px;
  
  }

  :where(.css-dev-only-do-not-override-apn68).ant-steps.ant-steps-vertical >.ant-steps-item {
  margin-bottom: 3rem !important;
  }

  :where(.css-dev-only-do-not-override-apn68).ant-steps .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #20ce78;
  border-color: #20ce78;
}

:where(.css-dev-only-do-not-override-apn68).ant-steps .ant-steps-item-finish .ant-steps-item-icon >.ant-steps-icon {
  color: #fff;
}

.anticon svg {

font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:where(.css-dev-only-do-not-override-apn68).ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
  background-color: #20ce78;
}

.div-RCsYGZvZUN {

position: relative;
} 

 .custom-confirm-modal {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-confirm-box {
    position: relative;
    background: #fff;
    padding: 2.5rem 2rem;
    border-radius: 1rem;
    max-width: 480px;
    width: 90%;
    text-align: center;
    background-image: url('/Images/p2.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .custom-confirm-box .close-btn {
    position: absolute;
    right: 1rem;
    top: 1rem;
    background: none;
    border: none;
    font-size: 2rem;
    color: #6b7280;
    cursor: pointer;
  }

/* Icon */
.icon-circle {
  background-color: #e0ecff;
  color: #A2AD91;
  font-size: 1.5rem;
  font-weight: bold;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

/* Title */
.custom-confirm-box h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #111827;
}

/* Message */
.custom-confirm-box p {
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

/* Buttons */
.btn-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.cancel-btn,
.confirm-btn {
  padding: 0.6rem 1.6rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-btn {
  background: #fff;
  border: 1px solid #d1d5db;
  color: #111827;
}

.confirm-btn {
  background: #2563eb;
  color: #fff;
  border: none;
}

.confirm-btn:hover {
  background: #1e40af;
}

/* Close Button (Top Right X) */
.close-btn {
  position: absolute;
  right: 1rem;
  top: 1rem;
  background: none;
  border: none;
  font-size: 2rem;
  color: #6b7280;
  cursor: pointer;
}

/* Success Modal Wrapper (Backdrop) */
.success-modal-wrapper {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Success Modal Box */
.success-modal-box {
  position: relative;
  background: #fff;
  padding: 2.5rem 2rem;
  border-radius: 1rem;
  max-width: 480px;
  width: 90%;
  text-align: center;
  box-shadow:
    0 0 0 20px rgba(255, 255, 255, 0.8),
    0 10px 25px rgba(0, 0, 0, 0.1);
  animation: pop-in 0.3s ease;
}

/* Success Icon */
.success-modal-icon {
  font-size: 3.5rem;
  color: #3f51b5;
  margin-bottom: 1rem;
}

/* Success Modal Title */
.success-modal-box h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.5rem;
}

/* Success Modal Message */
.success-modal-box p {
  font-size: 0.9rem;
  color: #6b7280;
}


  
`;

  content = (
    <>
      <style>{Antdstyles}</style>
      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
      <div className="col-12 col-md-12 col-lg-12 col-xl-12 mb-3">
      
          <button className="bg-[#fff] inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground size-10" onClick={handleMoveBack}>
            <GoArrowLeft />
            <span className="sr-only">Back</span>
          </button>
        <div className="card">
          {/* Progress Bar */}
          <div className="progress" style={{ height: "6px" }}>
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${progressWidth}%`, backgroundColor: "#A2AD91" }}
              aria-valuenow={progressWidth}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>

          {/* Step Content */}

          <form onSubmit={formik.handleSubmit}>
            {steps[currentStep - 1].content}

            {/* Navigation Buttons */}

            <div
              className={`d-flex mt-3 ${
                currentStep === 1
                  ? "justify-content-end"
                  : "justify-content-between"
              }`}
            >
              {currentStep !== 1 && (
                <button
                  className="gradient-dark-button px-4"
                  onClick={() => handleBack(currentStep, setCurrentStep)}
                  type="button"
                >
                  Back
                </button>
              )}

              <button
                className="gradient-button px-4"
                onClick={async () => {
                  if (currentStep === steps.length) {
                    confirmAlert({
                      customUI: ({ onClose }) => {
                        return (
                          <div className="custom-confirm-modal">
                            <div
                              className="custom-confirm-box"
                              style={{
                                backgroundImage: "url('/Images/p2.png')",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                              }}
                            >
                              <button className="close-btn" onClick={onClose}>
                                ×
                              </button>
                              <div className="icon-circle">?</div>
                              <h2>Does this work for you?</h2>
                              <p>
                                {isEditMode ? "Are You Sure Want To Update The Doctor?": "Are You Sure Want To Add The Doctor?"}
                              </p>
                              <div className="btn-group">
                                <button
                                  className="btn-back px-4"
                                  onClick={onClose}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="gradient-button px-4"
                                  onClick={async () => {
                                    await formik.submitForm();

                                    if (
                                      Object.keys(formik.errors).length === 0
                                    ) {
                                      onClose();
                                      confirmAlert({
                                        customUI: ({ onClose }) => {
                                          return (
                                            <div
                                              style={{
                                                position: "fixed",
                                                inset: 0,
                                                background:
                                                  "rgba(0, 0, 0, 0.2)",
                                                zIndex: 9999,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  position: "relative",
                                                  background: "#fff",
                                                  padding: "2.5rem 2rem",
                                                  borderRadius: "1rem",
                                                  maxWidth: "480px",
                                                  width: "90%",
                                                  textAlign: "center",
                                                  backgroundImage:
                                                    "url('/Images/p2.png')",
                                                  backgroundSize: "cover",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundPosition: "center",
                                                }}
                                              >
                                                <button
                                                  onClick={onClose}
                                                  style={{
                                                    position: "absolute",
                                                    right: "1rem",
                                                    top: "1rem",
                                                    background: "none",
                                                    border: "none",
                                                    fontSize: "2rem",
                                                    color: "#6b7280",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  ×
                                                </button>
                                                <div
                                                  style={{
                                                    fontSize: "3.5rem",
                                                    color: "#3f51b5",
                                                    marginBottom: "1rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <FaUserDoctor color="#A2AD91" />
                                                </div>
                                                <h2
                                                  className="px-4"
                                                  style={{
                                                    fontSize: "1.25rem",
                                                    fontWeight: 600,
                                                    color: "#111827",
                                                    marginBottom: "0.5rem",
                                                  }}
                                                >
                                                  {doctorData
                                                    ? "The Doctor Had Been Updated Successfully."
                                                    : "The Doctor Had Been Added Successfully."}
                                                </h2>
                                                <p
                                                  className="px-4"
                                                  style={{
                                                    fontSize: "0.9rem",
                                                    color: "#6b7280",
                                                    marginBottom: "1.5rem",
                                                  }}
                                                >
                                                  {doctorData
                                                    ? "All information about doctor has been Updated successfully"
                                                    : "All information about doctor has been added successfully"}
                                                </p>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "1rem",
                                                  }}
                                                >
                                                  <button
                                                    onClick={() => {
                                                      onClose();
                                                      navigate("/doctors");
                                                    }}
                                                    className="gradient-dark-button w-100"
                                                  >
                                                    Back To Doctor List
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        },
                                      });
                                    } else {
                                      toast.error(
                                        "Please fill all required fields correctly."
                                      );
                                    }
                                  }}
                                >
                                  Confirm
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      },
                    });
                  } else {
                    handleNext(currentStep, steps, setCurrentStep, formik);
                  }
                }}
                type="button"
                disabled={formik.isSubmitting}
              >
                {currentStep === steps.length ? "Finish" : "Next"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={30000} />
    </>
  );

  return content;
}

export default DoctorsStepper;
